import React, {Component} from 'react';
import _ from 'lodash';
import Promise from 'bluebird';
import JWT from 'jsonwebtoken';
import Api from 'util/Api';
import AuthContext from 'util/AuthContext';

// const config = require(`config-${process.env.REACT_APP_ENV}.json`);

class Provider extends Component {
    constructor(props){
        super(props);

        this.clearAuth = this.clearAuth.bind(this);
        this.isTokenExpired = this.isTokenExpired.bind(this);
        this.loadSavedAuth = this.loadSavedAuth.bind(this);
        this.logout = this.logout.bind(this);
        this.saveAuth = this.saveAuth.bind(this);
        this.stateToProvide = this.stateToProvide.bind(this);
        this.submitLogin = this.submitLogin.bind(this);

        this.onLogin = this.onLogin.bind(this);
        this.onOrganizationDetails = this.onOrganizationDetails.bind(this);
        this.onFacilityDetails = this.onFacilityDetails.bind(this);
        this.onSectionDetails = this.onSectionDetails.bind(this);

        this.isDemoUser = this.isDemoUser.bind(this);

        this.state = {
            db: null,
            currentUser: null,
            apiActionPending: false,
            initialized: false,
            clearAuth: this.clearAuth,
            submitLogin: this.submitLogin,
            logout: this.logout,
            onLogin: this.onLogin,
            onOrganizationDetails: this.onOrganizationDetails,
            onFacilityDetails: this.onFacilityDetails,
            onSectionDetails: this.onSectionDetails,
            isDemoUser: this.isDemoUser,
        };
    }

    componentDidMount() {
        this.loadSavedAuth();
    }

    isTokenExpired(currentUser) {
        const now = Date.now();

        const idToken = JWT.decode(currentUser.id_token);
        const idTokenExpiration = idToken.exp * 1000;
        return idTokenExpiration <= now;
    }

    clearAuth() {
        const essentials = _.omitBy(this.state, (val, key) => _.isFunction(val));
        this.setState({
            ..._.mapValues(essentials, () => null),
            initialized: true,
        });
        window.localStorage.removeItem('auth');
    }

    loadSavedAuth() {
        const savedUser = window.localStorage.getItem('auth');

        if (savedUser) {
            const currentUser = JSON.parse(savedUser);

            // Can't do anything if the token is expired
            if (this.isTokenExpired(currentUser)) {
                this.clearAuth();
            } else {
                this.setState({
                    ...this.state,
                    currentUser,
                    initialized: true,
                });
            }
        } else {
            this.setState({
                initialized: true,
            });
        }
    }

    saveAuth() {
        window.localStorage.setItem('auth', JSON.stringify(this.state.currentUser));
    }

    onLogin(response) {
        return Promise.fromCallback((callback) => {
            this.setState({
                currentUser: {
                    ...response,
                    defaultOrg: _.get(response, 'profile.defaultOrg'),
                    defaultFacility: _.get(response, 'profile.defaultFacility'),
                    defaultSection: _.get(response, 'profile.defaultSection'),
                    roles: _.get(response, 'profile.roles'),
                    role: _.get(response, 'profile.role')
                }
            }, callback);
        }
        )
            .then(this.saveAuth, (err) => {
                this.setState({
                    apiActionPending: false,
                    errorMessage: _.get(err, 'error.message.error_description', _.get(err, 'error.message', JSON.stringify(err))),
                });
            });
    }

    submitLogin({username, password}) {
        this.setState({
            apiActionPending: true,
        });

        Api.login({username, password})
            .then(this.onLogin, (err) => {
                this.setState({
                    apiActionPending: false,
                    errorMessage: _.get(err, 'error.message.error_description', _.get(err, 'error.message', JSON.stringify(err))),
                });
            });
    }

    logout() {
        Api.withAuth(this.stateToProvide()).logout().then(this.clearAuth);
    }

    onOrganizationDetails(organizationDetails) {
        this.setState({
            organizationDetails
        });
    }
    onFacilityDetails(facilityDetails) {
        this.setState({
            facilityDetails
        });
    }
    onSectionDetails(sectionDetails) {
        this.setState({
            sectionDetails
        });
    }

    isDemoUser() {
    // console.log('Demo user', _.get(this.state, 'currentUser.profile.isDemoUser', false), _.get(this.state, 'currentUser.profile'));
        return _.get(this.state, 'currentUser.profile.isDemoUser', false);
    }

    stateToProvide() {
        return _.omit(this.state);
    }

    render() {
        return (
            <AuthContext.Provider value={this.stateToProvide()}>
                {this.props.children}
            </AuthContext.Provider>
        );
    }
}

const withAuth = (WrappedComponent, options = {}) => {
    const HOC = class WithAuthWrapper extends Component {
        render() {
            return (
                <AuthContext.Consumer>
                    {(auth) =>
                        <WrappedComponent {...this.props} auth={auth} />
                    }
                </AuthContext.Consumer>
            );
        }
    };

    return HOC;
};

export default {Provider, withAuth};
